/* ============================================================
   Maui Craft Creations — Storefront Pages JavaScript
   Handles: variant picker, gallery, quantity steppers,
   accordions, header search toggle, cart helpers.
   Vanilla JS, no dependencies. Loaded site-wide (deferred).
   ============================================================ */
(function () {
  'use strict';

  /* ── Quantity steppers ── */
  function initQtySteppers(scope) {
    (scope || document).querySelectorAll('.mcc-qty').forEach(function (qty) {
      var input = qty.querySelector('input');
      if (!input) return;
      qty.querySelectorAll('button[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
          var min = parseInt(input.getAttribute('min'), 10);
          if (isNaN(min)) min = 1;
          var val = parseInt(input.value, 10) || min;
          val = Math.max(min, val + step);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ── Accordions ── */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('.mcc-acc-head').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.mcc-acc-item');
        var body = item && item.querySelector('.mcc-acc-body');
        if (!item || !body) return;
        var open = item.classList.toggle('is-open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ── Product gallery ── */
  function initGalleries(scope) {
    (scope || document).querySelectorAll('[data-mcc-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-mcc-gallery-main]');
      if (!main) return;
      gallery.querySelectorAll('.mcc-thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-img');
          if (!src) return;
          var img = new Image();
          img.onload = function () {
            main.style.opacity = '0';
            setTimeout(function () { main.src = src; main.style.opacity = '1'; }, 100);
          };
          img.src = src;
          gallery.querySelectorAll('.mcc-thumb').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ── Product variant picker ── */
  function initVariantPickers(scope) {
    (scope || document).querySelectorAll('[data-mcc-product]').forEach(function (form) {
      var dataEl = document.getElementById(form.getAttribute('data-variant-json'));
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var variants = (data && data.variants) || [];
      var idInput  = form.querySelector('[data-mcc-variant-id]');
      var priceEl  = form.querySelector('[data-mcc-price]');
      var compareEl = form.querySelector('[data-mcc-compare]');
      var addBtn   = form.querySelector('[data-mcc-add]');
      var addLabel = addBtn ? addBtn.querySelector('[data-mcc-add-label]') : null;
      var mainImg  = document.querySelector('[data-mcc-gallery-main]');

      function selectedOptions() {
        return Array.prototype.map.call(form.querySelectorAll('.mcc-option'), function (group) {
          var active = group.querySelector('.mcc-swatch.is-active');
          return active ? active.getAttribute('data-value') : null;
        });
      }

      function matchVariant(opts) {
        return variants.find(function (v) {
          return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function render() {
        var sel = selectedOptions(); var v = sel.length ? matchVariant(sel) : variants[0];
        if (!v) {
          if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); }
          if (addLabel) addLabel.textContent = 'Unavailable';
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price;
        if (compareEl) {
          if (v.compare) { compareEl.textContent = v.compare; compareEl.style.display = ''; }
          else { compareEl.textContent = ''; compareEl.style.display = 'none'; }
        }
        if (addBtn) {
          if (v.available) { addBtn.removeAttribute('disabled'); if (addLabel) addLabel.textContent = 'Add to cart'; }
          else { addBtn.setAttribute('disabled', 'disabled'); if (addLabel) addLabel.textContent = 'Sold out'; }
        }
        if (mainImg && v.img) {
          var img = new Image();
          img.onload = function () {
            mainImg.style.opacity = '0';
            setTimeout(function () { mainImg.src = v.img; mainImg.style.opacity = '1'; }, 100);
          };
          img.src = v.img;
        }
      }

      form.querySelectorAll('.mcc-option').forEach(function (group) {
        group.querySelectorAll('.mcc-swatch').forEach(function (sw) {
          sw.addEventListener('click', function () {
            group.querySelectorAll('.mcc-swatch').forEach(function (s) { s.classList.remove('is-active'); });
            sw.classList.add('is-active');
            render();
          });
        });
      });
      render();
    });
  }

  /* ── Header search toggle ── */
  function initSearchToggle() {
    document.querySelectorAll('[data-mcc-search-toggle]').forEach(function (btn) {
      var targetId = btn.getAttribute('data-mcc-search-toggle');
      var bar = document.getElementById(targetId);
      if (!bar) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = bar.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = bar.querySelector('input[type="search"], input[name="q"]');
          if (input) setTimeout(function () { input.focus(); }, 60);
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && bar.classList.contains('open')) {
          bar.classList.remove('open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ── Cart: auto-update line quantities ── */
  function initCart() {
    var form = document.getElementById('mcc-cart-form');
    if (!form) return;
    form.querySelectorAll('.mcc-qty input').forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
  }

  /* ── Init ── */
  function init() {
    initQtySteppers(document);
    initAccordions(document);
    initGalleries(document);
    initVariantPickers(document);
    initSearchToggle();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
